var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationNewDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 22V20.5H6.1V12.85C6.1 11.45 6.5125 10.2042 7.3375 9.1125C8.1625 8.02083 9.25 7.33333 10.6 7.05V6.325C10.6 5.94167 10.7375 5.625 11.0125 5.375C11.2875 5.125 11.6167 5 12 5C12.3833 5 12.7125 5.125 12.9875 5.375C13.2625 5.625 13.4 5.94167 13.4 6.325V7.05C14.75 7.33333 15.8417 8.02083 16.675 9.1125C17.5083 10.2042 17.925 11.45 17.925 12.85V20.5H20V22H4ZM12 25C11.4667 25 11 24.8042 10.6 24.4125C10.2 24.0208 10 23.55 10 23H14C14 23.55 13.8042 24.0208 13.4125 24.4125C13.0208 24.8042 12.55 25 12 25ZM7.6 20.5H16.425V12.85C16.425 11.6167 16 10.5667 15.15 9.7C14.3 8.83333 13.2583 8.4 12.025 8.4C10.7917 8.4 9.74583 8.83333 8.8875 9.7C8.02917 10.5667 7.6 11.6167 7.6 12.85V20.5Z",
    fill: "#282A30"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 7,
    r: 4,
    fill: "#E13E3E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 7,
    r: 5.5,
    stroke: "white",
    strokeOpacity: 0.98,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNewDark);
export default __webpack_public_path__ + "static/media/notification_new_dark.5ddc3d63632ff12f7be41303a2ec194e.svg";
export { ForwardRef as ReactComponent };